<div class="celum-systembar_wrapper">
  @if (systembar()?.services) {
    <systembar-service-tabs [services]="systembar().services"></systembar-service-tabs>
  }

  <div class="celum-systembar_growing-place-holder"></div>

  <ng-content class="center-content" select="[notifications]"></ng-content>

  <!-- Deprecated, should be removed with https://celum.atlassian.net/browse/CH-9973 -->
  <ng-content class="center-content" select="[formats]"></ng-content>

  @if (systembar()?.accessToOrganisationDetailsEnabled) {
    <div>
      <systembar-service-tab-item [service]="systembar().organisationDetails"></systembar-service-tab-item>
    </div>
  }

  <systembar-avatar class="celum-systembar_components" [avatar]="systembar()?.avatar" [languages]="systembar()?.languages" [user]="systembar()?.user">
    <ng-content select="[small-avatar]" ngProjectAs="[small-avatar]"></ng-content>
    <ng-content select="[big-avatar]" ngProjectAs="[big-avatar]"></ng-content>
  </systembar-avatar>

  <systembar-help class="celum-systembar_components" [contextMenuItems]="systembar()?.helpContextMenuItems"></systembar-help>
</div>
